import { render, staticRenderFns } from "./TabOrders.vue?vue&type=template&id=daad16a2&"
import script from "./TabOrders.vue?vue&type=script&lang=js&"
export * from "./TabOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports